import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageToggle() {
    const { language, toggleLanguage } = useLanguage();

    return (
        <motion.button
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.2, type: "spring", stiffness: 100 }}
            onClick={toggleLanguage}
            className="fixed top-24 left-4 md:top-28 md:left-8 z-50 px-6 py-3 rounded-full flex items-center gap-2 bg-[--bg-secondary] shadow-md hover:bg-[--accent] transition-all group"
            aria-label="Toggle Language"
        >
            <motion.span
                className="text-sm font-semibold text-[--text-primary] group-hover:text-black transition-colors"
                animate={{ scale: language === 'it' ? 1.1 : 1 }}
            >
                IT
            </motion.span>
            <div className="w-px h-4 bg-[--border-color]" />
            <motion.span
                className="text-sm font-semibold text-[--text-primary] group-hover:text-black transition-colors"
                animate={{ scale: language === 'en' ? 1.1 : 1 }}
            >
                EN
            </motion.span>

            {/* Active indicator */}
            <motion.div
                className="absolute bottom-0 left-0 h-0.5 bg-[--accent]"
                animate={{
                    x: language === 'it' ? '0.5rem' : 'calc(100% - 2.5rem)',
                    width: '1.5rem'
                }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
            />
        </motion.button>
    );
}
